module.exports = __webpack_public_path__ + "img/characterAnime9.d61ebd49.png";